var swiperHero = new Swiper('.swiper-container__hero', {
	autoplay: {
		delay: 4000,
	},
	loop: true,
	waitForTransition: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
});

var swiperShipping = new Swiper('.swiper-container__shipping', {
	navigation: {
		nextEl: '.slide-button-next',
		prevEl: '.slide-button-prev',
	},
});

$(document).ready(function () {
	$(".slide-button").click(function () {

		var slide = $(".active-next");

		if(slide.hasClass("swiper-slide-active")) {
			$(".slide-button-next").addClass("active");
		} else {
			$(".slide-button-next").removeClass("active");
		}
	});
});

var hero = new TimelineMax({ onUpdate: updatePercentage });
var slide = new TimelineMax({ onUpdate: updatePercentage });
var benefits = new TimelineMax({ onUpdate: updatePercentage });
var ingredients = new TimelineMax({ onUpdate: updatePercentage });
var comments = new TimelineMax({ onUpdate: updatePercentage });
var instructions = new TimelineMax({ onUpdate: updatePercentage });

const controller = new ScrollMagic.Controller();

slide.from('.slide', 1, { y: 200, opacity: 0, ease: Power4.easeInOut });

const sceneSlide = new ScrollMagic.Scene({
	triggerElement: "#slide",
	triggerHook: "onEnter",
	reverse: false
})
.setTween(slide)
.addTo(controller);

benefits.from('.benefits__image', 1, { x: -150, opacity: 0, ease: Power4.easeInOut });
benefits.from('.benefits__text', 1, { opacity: 0, ease: Power4.easeInOut }, "=-0.3");
benefits.from('.benefits__title', 1, { opacity: 0, ease: Power4.easeInOut }, "=-0.3");
benefits.from('.benefits__item:nth-child(1)', 1, { y: 100, opacity: 0, ease: Power4.easeInOut });
benefits.from('.benefits__item:nth-child(2)', 1, { y: 100, opacity: 0, ease: Power4.easeInOut }, "=-0.7");
benefits.from('.benefits__item:nth-child(3)', 1, { y: 100, opacity: 0, ease: Power4.easeInOut }, "=-0.7");
benefits.from('.benefits__item:nth-child(4)', 1, { y: 100, opacity: 0, ease: Power4.easeInOut }, "=-0.7");
benefits.from('.benefits__item:nth-child(5)', 1, { y: 100, opacity: 0, ease: Power4.easeInOut }, "=-0.7");
benefits.from('.benefits__item:nth-child(6)', 1, { y: 100, opacity: 0, ease: Power4.easeInOut }, "=-0.7");

const sceneBenefits = new ScrollMagic.Scene({
	triggerElement: "#benefits",
	triggerHook: "onEnter",
	reverse: false
})
.setTween(benefits)
.addTo(controller);


ingredients.from('.ingredients__image', 1, { y: 75, opacity: 0, ease: Power4.easeInOut });
ingredients.from('.ingredients__title', 1, { y: 75, opacity: 0, ease: Power4.easeInOut });
ingredients.from('.ingredients__item:nth-child(1)', 1, { x: -50, opacity: 0, ease: Power4.easeInOut });
ingredients.from('.ingredients__item:nth-child(2)', 1, { x: -50, opacity: 0, ease: Power4.easeInOut }, "=-0.7");
ingredients.from('.ingredients__item:nth-child(3)', 1, { x: -50, opacity: 0, ease: Power4.easeInOut }, "=-0.7");
ingredients.from('.ingredients__item:nth-child(4)', 1, { x: -50, opacity: 0, ease: Power4.easeInOut }, "=-0.7");
ingredients.from('.ingredients__item:nth-child(5)', 1, { x: -50, opacity: 0, ease: Power4.easeInOut }, "=-0.7");
ingredients.from('.ingredients__item:nth-child(6)', 1, { x: -50, opacity: 0, ease: Power4.easeInOut }, "=-0.7");

const sceneIngredients = new ScrollMagic.Scene({
	triggerElement: "#ingredients",
	triggerHook: "onEnter",
	reverse: false
})
.setTween(ingredients)
.addTo(controller);


comments.from('.comments__item:nth-child(1)', 0.2, { y: 55, scale: .7, opacity: 0, ease: Power4.easeInOut });
comments.from('.comments__item:nth-child(2)', 0.2, { y: 55, scale: .7, opacity: 0, ease: Power4.easeInOut });
comments.from('.comments__item:nth-child(3)', 0.2, { y: 55, scale: .7, opacity: 0, ease: Power4.easeInOut });
comments.from('.comments__item:nth-child(4)', 0.2, { y: 55, scale: .7, opacity: 0, ease: Power4.easeInOut });

const sceneComments = new ScrollMagic.Scene({
	triggerElement: "#comments",
	triggerHook: "center",
	reverse: false
})
.setTween(comments)
.addTo(controller);


instructions.from('.instructions__image', 1, { opacity: 0, ease: Power4.easeInOut });

const sceneInstructions = new ScrollMagic.Scene({
	triggerElement: "#instructions",
	triggerHook: "center",
	reverse: false
})
.setTween(instructions)
.addTo(controller);

function updatePercentage() {
	hero.progress();
	slide.progress();
	benefits.progress();
	ingredients.progress();
	comments.progress();
	instructions.progress();
}